<template>
	<v-snackbar 
		v-model="snackbar" 
		:timeout="0" 
		top
		auto-height
	>
		<div style="margin: -14px auto; width: 100%">
			<div style="margin: 0 -24px">
				<template v-for="(n, index) in notifications">
					<Notification
						:key="n.id"
						:notification="n"
						@remove="removeNotification(n)"
					/>
					<div style="margin-top: 3px; background-color: #ccc;"
						v-if="index != lastIndex"
						:key="`${n.id}-dvider`"
					/>
				</template>
			</div>
		</div>
	</v-snackbar>
</template>
<script>
import Notification from './Notification';

export default {
	name: 'SnackbarNotification',
	components: {
		Notification,
	},
	methods: {
		onCloseSnackbar: function() {
			this.$store.dispatch('closeSnackbar');
		},
		removeNotification: function(n) {
			this.$store.dispatch('removeNotification', n);
		},
	},
	computed: {
		snackbar: function() {
			return this.$store.getters.notifications.length > 0;
		},
		notifications: function() {
			return this.$store.getters.notifications;
		},
		lastIndex() {
			return this.notifications.length - 1;
		},
	},
}
</script>
<style>
.v-snack__wrapper{
	background-color: #CCC;
}
</style>